import React, { useEffect, useState } from 'react';

import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';
import TextField from '@material-ui/core/TextField';
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import moment from 'moment';

export default WithApp(function ModalCuotaSupervisor(props) {
  const cuota = props.model;
  const [dataChanging, setDataChanging] = useState([]);
  const [category, setCategory] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  async function listCategories() {
    let response = await wsFindBy('logi/category', { state: 'A', deleted_at: 'null', base_business_partner_id: 7 });
    if (response.success) setCategory(response.data);
  }

  useEffect(() => {
    if (cuota.open) {
      setDataChanging([]);
      listCategories();
    }
  }, [cuota.open]);

  useEffect(() => {
    if (category.length > 0 && cuota.logi_category_id) {
      handleChange("logi_category_id", String(cuota.logi_category_id));
    }
  },[category]);

  return (
    <>
      <Modal
        title={`Nueva Cuota de Categoria`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/cuota-categoria-periodo'
        dataForce={
          {logi_category_id: dataChanging.logi_category_id}
        }
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <Autocomplete
          disableClearable
          options={category}
          getOptionLabel={(item) => `${item.description}`}
          renderInput={(params) => (
            <TextField {...params} label="Categoria" margin="normal" fullWidth />
          )}
          onChange={(e, item) => {handleChange('logi_category_id', item?.id);}}
          value={category.find((cat) => String(cat.id) === String(dataChanging.logi_category_id)) || null }
        />
        <TextField
          label="Descripción"
          fullWidth
          type="text"
          name="description"
          margin="normal"
          defaultValue={!!cuota ? cuota.description : ''}
          onChange={(e) => handleChange('description', e.target.value)}
          required
        />
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="cuota"
          margin="normal"
          defaultValue={!!cuota ? cuota.cuota : ''}
          onChange={(e) => handleChange('cuota', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});

